const checkboxGroupContextKey = /* @__PURE__ */ Symbol("checkboxGroupContextKey");

export { checkboxGroupContextKey };
//# sourceMappingURL=constants.mjs.map
